<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <h4 class="page-title">
          <i class="fas fa-file-invoice-dollar mr-2"></i>Notas Fiscais
        </h4>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <kendo-tabstrip class="nav-bordered">
            <kendo-tabstrip-tab [title]="'Emissão de Notas Fiscais'" [selected]="true">
              <ng-template kendoTabContent>
                <div class="py-4">
                  <app-grid-nfce></app-grid-nfce>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab [title]="'Configurações'">
              <ng-template kendoTabContent>
                <div class="py-4">
                  <kendo-tabstrip class="nav-bordered">
                    <kendo-tabstrip-tab [title]="'Configurações Gerais'" [selected]="true">
                      <ng-template kendoTabContent>
                        <div class="py-4">
                          <app-configuracoes-fiscal></app-configuracoes-fiscal>
                        </div>
                      </ng-template>
                    </kendo-tabstrip-tab>


                    <kendo-tabstrip-tab [title]="'Tributação de Produção Própria'">
                      <ng-template kendoTabContent>
                        <div class="py-4">
                          <div class="card shadow-sm">
                            <div class="card-body">
                              <h5 class="card-title mb-4">Configuração de Tributação - Produção Própria</h5>
                              <app-tributacao-nat-op propriaOuTerceiros="PROPRIA"></app-tributacao-nat-op>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </kendo-tabstrip-tab>

                    <kendo-tabstrip-tab [title]="'Tributação de Produtos de Terceiros'">
                      <ng-template kendoTabContent>
                        <div class="py-4">
                          <div class="card shadow-sm">
                            <div class="card-body">
                              <h5 class="card-title mb-4">Configuração de Tributação - Produtos de Terceiros</h5>
                              <app-tributacao-nat-op propriaOuTerceiros="TERCEIROS"></app-tributacao-nat-op>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </kendo-tabstrip-tab>
                  </kendo-tabstrip>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </div>
      </div>
    </div>
  </div>
</div>
